export interface OAuthSessionTimeoutInput {
  accessTokenExpiresAtMs: number;
  refreshTokenExpiresAtMs: number;
}

export function getSafeOAuthSessionTimeoutMs({
  accessTokenExpiresAtMs,
  refreshTokenExpiresAtMs,
}: OAuthSessionTimeoutInput): number {
  const nowMs = Date.now();
  const configuredTimeoutMs = refreshTokenExpiresAtMs - accessTokenExpiresAtMs;
  const refreshTokenRemainingMs = refreshTokenExpiresAtMs - nowMs;

  if (configuredTimeoutMs <= 0) {
    return Math.max(0, refreshTokenRemainingMs);
  }

  return Math.max(0, Math.min(configuredTimeoutMs, refreshTokenRemainingMs));
}